const STORAGE_KEY = 'sessionTime';


export const getSessionTime = () => {
  const sessionTime = sessionStorage.getItem(STORAGE_KEY);
  return sessionTime ? Number(sessionTime) : null;
};

export const setSessionTime = (value) => {
  sessionStorage.setItem(STORAGE_KEY, String(value ?? +Date.now()));
};

export const resetSessionTime = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
